import React from 'react';
import {
  Box,
  Grid,
  Typography,
  Container,
  ListItemIcon,
  List,
  ListItem,
  ListItemText,

} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import HeaderBanner from '../../assets/others/term-and-condition.png';
import PageBreadcrumb from '../../components/other/PageBreadcrumb';

import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';




const TermsAndConition = (props) => {
  const { isMobile = false } = props;
  const Mobile = useMediaQuery('(max-width:480px)');
  const location = useLocation();
  const canonicalUrl = `https://www.99gift.ae${location.pathname}`;
  const backgroundColor = Mobile ? '#fff' : 'white.main';
  const giftCardContiner = {
    boxShadow: { xs: 0, sm: 1, md: 2 },
    borderRadius: { xs: 0, sm: 1, md: 3 },
    p: { xs: 0, sm: 2, md: 3 },
    my: { xs: 2, sm: 3, md: 3 },
    backgroundColor: backgroundColor,
    fontFamily:"Be Vietnam Pro"
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>Terms and Conditions - 99Gift</title>
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:title" content="Terms and Conditions - 99Gift" />
        <link rel="canonical" href={canonicalUrl} /> {/* Dynamic Canonical URL */}
      </Helmet>

      {!isMobile && (
        <Container maxWidth="xl">
          <PageBreadcrumb home="Home" currentProduct="Terms & Conditions" />
        </Container>
      )}

      <Container maxWidth="false" disableGutters>
        <Box
          sx={{
            objectFit: 'cover',
            minHeight: { sm: '216px' },
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <img
            src={HeaderBanner}
            alt="Header Banner"
            style={{ objectFit: 'contain', width: '100%', height: 'auto' }}
          />
        </Box>
      </Container>

      <Container
        maxWidth="false"
        disableGutters
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: {
            xs: 'white.main',
            md: '#F1F5F6',
          },
        }}
      >
        <Grid
          container
          alignItems="center"
          maxWidth="lg"
          sx={{
            px: { xs: 2, md: 0 },
            justifyContent: 'center',
          }}
        >
          <Grid item xs={12} sx={{ mt: { xs: 3, sm: 3 } }}>
            <Typography
              variant="subtitle2"
              color="secondary.main"
              sx={{
                fontSize: { xs: '14.5px', md: '18px' },
                textAlign: { xs: 'center', sm: 'left' },
                textTransform: 'uppercase',
              }}
            >
              Terms & Conditions
            </Typography>
            <TermsAndConitionData giftCardContiner={giftCardContiner} />
          </Grid>
          <Grid item xs={12} sx={{ mt: { xs: 1, sm: 1 } }}>
            <TermsAndConitionGeneralUse giftCardContiner={giftCardContiner} />

            <TermsAndConitionInformationCollection giftCardContiner={giftCardContiner} />

            <TermsAndConitionAccountAndPassword giftCardContiner={giftCardContiner} />
            <TermsAndConitionPrivacyPolicy giftCardContiner={giftCardContiner} />
            <TermsAndConitionUserObligations giftCardContiner={giftCardContiner} />
            <TermsAndConitionUsageConduct giftCardContiner={giftCardContiner} />
            <TermsAndConitionIntellectualPropertyRights giftCardContiner={giftCardContiner} />
            <TermsAndConitionThirdPartySites giftCardContiner={giftCardContiner} />
            <TermsAndConitionDisclaimer giftCardContiner={giftCardContiner} />
            <TermsAndConitionIndemnification giftCardContiner={giftCardContiner} />
            <TermsAndConitionTermination giftCardContiner={giftCardContiner} />
            <TermsAndConitionGoverningLaw giftCardContiner={giftCardContiner} />
            <TermsAndConitionReportAbuse giftCardContiner={giftCardContiner} />
          </Grid>
          <Grid item xs={12} sx={{ mt: { xs: 3, sm: 3 } }}>
            <TermsAndConitionSharedPersonalInformation giftCardContiner={giftCardContiner} />
            <TermsAndConitionGeneral giftCardContiner={giftCardContiner} />
          </Grid>

          <Grid item xs={12} sx={{ mt: { xs: 3, sm: 3 } }}>
            <Typography
              variant="subtitle2"
              color="primary.main"
              sx={{
                fontSize: { xs: '14.5px', md: '18px' },
                textAlign: { xs: 'center', sm: 'left' },
                textTransform: 'uppercase',
              }}
            >
              14. Contact Information{' '}
            </Typography>

            <Grid
              container
              sx={{
                ...giftCardContiner,
              }}
            >
              <Grid item xs={12}>
                <Typography
                  variant="subtitle2"
                  color="primary.main"
                  sx={{
                    fontSize: { xs: '13.5px', md: '14px' },
                    color: 'dark.main',
                    fontWeight: { xs: 400, md: 400 },
                    display: 'block',
                    textTransform: 'capitalize',
                    mt: { xs: 1, sm: 1 },
                  }}
                >
                  'For questions regarding these Terms, customer support, or Gift Card issues,
                  please contact us via the support details listed on the Contact Us page of
                  99gift.ae.'
                </Typography>
                <Typography
                  variant="subtitle2"
                  color="primary.main"
                  sx={{
                    fontSize: { xs: '13.5px', md: '14px' },
                    color: 'dark.main',
                    fontWeight: { xs: 400, md: 400 },
                    display: 'block',
                    textTransform: 'capitalize',
                    mt: { xs: 1, sm: 1 },
                  }}
                >
                  <strong> Company Name:</strong> : Zpay Solutions L.L.C-FZ
                </Typography>
                {/* <Typography
                  variant="subtitle2"
                  color="primary.main"
                  sx={{
                    fontSize: { xs: '13.5px', md: '14px' },
                    color: 'dark.main',
                    fontWeight: { xs: 400, md: 400 },
                    display: 'block',
                    textTransform: 'capitalize',
                    mt: { xs: 1, sm: 1 },
                  }}
                >
                  <strong>Address:</strong>: Meydan Grandstand, 6th floor, Meydan Road, Nad Al
                  Sheba, Dubai, U.A.E.
                </Typography> */}

                {/* <Typography
                  variant="subtitle2"
                  color="primary.main"
                  sx={{
                    fontSize: { xs: '13.5px', md: '14px' },
                    color: 'dark.main',
                    fontWeight: { xs: 400, md: 400 },
                    display: 'block',
                    mt: { xs: 1, sm: 1 },
                  }}
                >
                  <strong>Contact No.:</strong> <a href="tel:971563348249">971563348249</a>
                </Typography> */}
                {/* <Typography
                  variant="subtitle2"
                  color="primary.main"
                  sx={{
                    fontSize: { xs: '13.5px', md: '14px' },
                    color: 'dark.main',
                    fontWeight: { xs: 400, md: 400 },
                    display: 'block',
                    mt: { xs: 1, sm: 1 },
                  }}
                >
                  <strong>Email:</strong>{' '}
                  <a href="mailto:marketing@gzonic.com">marketing@gzonic.com</a>
                </Typography> */}
                {/* <Typography
                  variant="subtitle2"
                  color="primary.main"
                  sx={{
                    fontSize: { xs: '13.5px', md: '14px' },
                    color: 'dark.main',
                    fontWeight: { xs: 400, md: 400 },
                    display: 'block',
                    mt: { xs: 1, sm: 1 },
                  }}
                >
                  <strong>Availability:</strong>Monday to Friday, from 09:00 AM to 05:00 PM (CET).

                </Typography> */}
                 {/* <Typography
                  variant="subtitle2"
                  color="primary.main"
                  sx={{
                    fontSize: { xs: '13.5px', md: '14px' },
                    color: 'dark.main',
                    fontWeight: { xs: 400, md: 400 },
                    display: 'block',
                    mt: { xs: 1, sm: 1 },
                  }}
                >
                  <strong> Company registration details: 2536281</strong>
                </Typography> */}

              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </React.Fragment>
  );
};

TermsAndConition.propTypes = {};

export default TermsAndConition;

function TermsAndConitionInnerTitle({ param1, param2 }) {
  return (
    <React.Fragment>
      {param1 && (
        <Typography
          variant="h3"
          color="priimary.main"
          sx={{
            display: 'inline',
            fontSize: { xs: '14.5px', md: '18px' },
          }}
        >
          {param1}
        </Typography>
      )}
      {param2 && (
        <Typography
          variant="h3"
          color="secondary.main"
          sx={{
            display: 'inline',
            ml: { xs: '2px', md: '3px' },
            fontSize: { xs: '14.5px', md: '18px' },
          }}
        >
          {param2}
        </Typography>
      )}
    </React.Fragment>
  );
}

function TermsAndConitionSimpleParagraph({ paragrpahData }) {
  return (
    <Typography
      variant="subtitle2"
      color="primary.main"
      sx={{
        fontSize: { xs: '13.5px', md: '14px' },
        color: 'dark.main',
        fontWeight: { xs: 400, md: 400 },
        display: 'block',
        textTransform: 'capitalize',
        mt: { xs: 1, sm: 1 },
      }}
    >
      {paragrpahData}
    </Typography>
  );
}

function TermsAndConitionData({ giftCardContiner }) {
  const paragraph = 'These Terms and Conditions govern your use of the website 99gift.ae (“Website”) and the purchase and redemption of digital gift cards (“Gift Cards”) offered on this platform. By accessing or using our Website, purchasing, receiving, or redeeming a Gift Card, you agree to be legally bound by these Terms. If you do not agree with these Terms, please do not use this Website or its services.';
  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
          <TermsAndConitionSimpleParagraph paragrpahData={paragraph} />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

function TermsAndConitionGeneralUse({ giftCardContiner }) {
  const orders = [
    {
      content: '“We”, “Us”, “Our” refers to 99gift.ae and its authorized operators.',
    },
    {
      content:
        '“You”, “User”, “Customer” means any individual or legal entity using the Website or purchasing a Gift Card.',
    },
    {
      content:
        '“Gift Card” means any prepaid digital voucher with a stored value redeemable according to the issuer’s terms.',
    },
    {
      content:
        '“Issuer” denotes the third-party brand or merchant that issues the Gift Card or accepts it for redemption.',
    },
  ];

  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <TermsAndConitionInnerTitle
          param1="1. Definitions
"
        />

        <Grid item xs={12}>
          <List>
            {orders.map((order, index) => (
              <ListItem key={order.id} dense sx={{ pl: '0' }}>
                {order?.icon && (
                  <ListItemIcon sx={{ color: 'inherit' }}>{order?.icon}</ListItemIcon>
                )}
                {order?.content && (
                  <ListItemText
                    primary="&#9679;"
                    primaryTypographyProps={{
                      fontSize: { xs: '13.5px', md: '16px' },
                      color: 'secondary.main',
                      fontWeight: { xs: 400, md: 300 },
                      display: 'inline',

                      mr: { xs: '3px', md: '3px' },
                    }}
                    secondary={order?.content}
                    secondaryTypographyProps={{
                      fontSize: { xs: '13.5px', md: '16px' },
                      color: 'primary.main',
                      fontWeight: { xs: 400, md: 400 },
                      display: 'inline',
                    }}
                  />
                )}
              </ListItem>
            ))}
          </List>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

function TermsAndConitionInformationCollection({ giftCardContiner }) {
  const orders = [
    {
      content: 'You must be at least 18 years old to use or purchase a Gift Card on this Website.',
    },
    {
      content:
        '	By using this Website and purchasing a Gift Card, you affirm that you have the legal capacity to enter into these Terms.',
    },
    {
      content:
        'Gift Cards are intended for personal and lawful use only; commercial resale without permission is prohibited.',
    },
  ];

  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <TermsAndConitionInnerTitle param1="2. Eligibility and Acceptance" />

        <Grid item xs={12}>
          <List>
            {orders.map((order, index) => (
              <ListItem key={order.id} dense sx={{ pl: '0' }}>
                {order?.icon && (
                  <ListItemIcon sx={{ color: 'inherit' }}>{order?.icon}</ListItemIcon>
                )}
                {order?.content && (
                  <ListItemText
                    primary="&#9679;"
                    primaryTypographyProps={{
                      fontSize: { xs: '13.5px', md: '16px' },
                      color: 'secondary.main',
                      fontWeight: { xs: 400, md: 300 },
                      display: 'inline',

                      mr: { xs: '3px', md: '3px' },
                    }}
                    secondary={order?.content}
                    secondaryTypographyProps={{
                      fontSize: { xs: '13.5px', md: '16px' },
                      color: 'primary.main',
                      fontWeight: { xs: 400, md: 400 },
                      display: 'inline',
                    }}
                  />
                )}
              </ListItem>
            ))}
          </List>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

function TermsAndConitionAccountAndPassword({ giftCardContiner }) {
  const orders = [
    {
      content:
        'Gift Cards must be purchased online through approved payment methods displayed on this Website',
    },
    {
      content: '	All purchase amounts are denominated in United Arab Emirates Dirhams (AED).',
    },
    {
      content: 'Prices, availability, and promotions may change without prior notice.',
    },
  ];

  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <TermsAndConitionInnerTitle param1="3. Purchasing Gift Cards" />

        <Grid item xs={12}>
          <List>
            {orders.map((order, index) => (
              <ListItem key={order.id} dense sx={{ pl: '0' }}>
                {order?.icon && (
                  <ListItemIcon sx={{ color: 'inherit' }}>{order?.icon}</ListItemIcon>
                )}
                {order?.content && (
                  <ListItemText
                    primary="&#9679;"
                    primaryTypographyProps={{
                      fontSize: { xs: '13.5px', md: '16px' },
                      color: 'secondary.main',
                      fontWeight: { xs: 400, md: 300 },
                      display: 'inline',

                      mr: { xs: '3px', md: '3px' },
                    }}
                    secondary={order?.content}
                    secondaryTypographyProps={{
                      fontSize: { xs: '13.5px', md: '16px' },
                      color: 'primary.main',
                      fontWeight: { xs: 400, md: 400 },
                      display: 'inline',
                    }}
                  />
                )}
              </ListItem>
            ))}
          </List>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

// function TermsAndConitionCommunication() {
//   const paragraph = `99Gift may use the information submitted by you to send you e-mails and SMS for administrative and marketing purposes, through its servers and systems; or through third party e-mail Or SMS service providers. User can unsubscribe/opt-out from our communications sent on SMS and Email anytime:`;
//   return (
//     <React.Fragment>
//       <Grid container sx={{ mt: { xs: 1, md: 2 } }}>
//         <Grid item xs={12}>
//           <TermsAndConitionInnerTitle param2="Communication" />
//         </Grid>

//         <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
//           <TermsAndConitionSimpleParagraph paragrpahData={paragraph} />
//           <List>
//             <ListItem>
//               <ListItemText
//                 primary="&#9679;"
//                 primaryTypographyProps={{
//                   fontSize: { xs: '13.5px', md: '16px' },
//                   color: 'secondary.main',
//                   fontWeight: { xs: 400, md: 300 },
//                   display: 'inline',

//                   mr: { xs: '3px', md: '3px' },
//                 }}
//                 secondary="Please email us at info@99gift.ae to unsubscribe from SMS or E-mail."
//                 secondaryTypographyProps={{
//                   fontSize: { xs: '14.5px', md: '16px' },
//                   color: 'dark.main',
//                   fontWeight: { xs: 400, md: 400 },
//                   display: 'inline',
//                 }}
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="&#9679;"
//                 primaryTypographyProps={{
//                   fontSize: { xs: '13.5px', md: '16px' },
//                   color: 'secondary.main',
//                   fontWeight: { xs: 400, md: 300 },
//                   display: 'inline',
//                   mr: { xs: '3px', md: '3px' },
//                 }}
//                 secondary={`User can also un-subscribe from emails, by clicking the "Unsubscribe URL" mentioned in the footer of the emails.`}
//                 secondaryTypographyProps={{
//                   fontSize: { xs: '14.5px', md: '16px' },
//                   color: 'dark.main',
//                   fontWeight: { xs: 400, md: 400 },
//                   display: 'inline',
//                 }}
//               />
//             </ListItem>
//           </List>
//         </Grid>
//       </Grid>
//     </React.Fragment>
//   );
// }

// function TermsAndConitionFunctionalities() {
//   const paragraph = `This Website is an information gateway to the offers that 99Gift extends to the Users. Apart from providing information and a searchable database, the Website also hosts the platform for the online sale/purchase of 99Gift Gift Cards.`;
//   return (
//     <React.Fragment>
//       <Grid container>
//         <Grid item xs={12}>
//           <TermsAndConitionInnerTitle param2="Functionalities Offered" />
//         </Grid>

//         <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
//           <TermsAndConitionSimpleParagraph paragrpahData={paragraph} />
//         </Grid>
//       </Grid>
//     </React.Fragment>
//   );
// }

function TermsAndConitionPrivacyPolicy({ giftCardContiner }) {
  const orders = [
    {
      content:
        'After a successful purchase, digital Gift Cards are delivered instantly via email to the designated recipient email address.',
    },
    {
      content:
        'It is your responsibility to ensure the email address is correct; we are not liable if delivery fails due to incorrect information provided by you',
    },
    {
      content: 'Activation and balance validity are determined by the issuer’s specific terms',
    },
  ];

  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <TermsAndConitionInnerTitle param1="4. Gift Card Delivery and Activation" />

        <Grid item xs={12}>
          <List>
            {orders.map((order, index) => (
              <ListItem key={order.id} dense sx={{ pl: '0' }}>
                {order?.icon && (
                  <ListItemIcon sx={{ color: 'inherit' }}>{order?.icon}</ListItemIcon>
                )}
                {order?.content && (
                  <ListItemText
                    primary="&#9679;"
                    primaryTypographyProps={{
                      fontSize: { xs: '13.5px', md: '16px' },
                      color: 'secondary.main',
                      fontWeight: { xs: 400, md: 300 },
                      display: 'inline',

                      mr: { xs: '3px', md: '3px' },
                    }}
                    secondary={order?.content}
                    secondaryTypographyProps={{
                      fontSize: { xs: '13.5px', md: '16px' },
                      color: 'primary.main',
                      fontWeight: { xs: 400, md: 400 },
                      display: 'inline',
                    }}
                  />
                )}
              </ListItem>
            ))}
          </List>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

function TermsAndConitionUserObligations({ giftCardContiner }) {
  const orders = [
    {
      content:
        '	Gift Cards are redeemable only with the participating merchants or brands specified at the time of purchase.',
    },
    {
      content: ' Redemption may be subject to additional terms imposed by the issuing brand.',
    },
    {
      content:
        ' Gift Cards cannot be exchanged for cash, credit, or any other value unless required by applicable UAE law.',
    },
    {
      content:
        ' Lost, stolen, or unauthorized use of Gift Card codes is your responsibility; we are not liable for misuse once the code has been delivered. ',
    },
  ];

  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <Grid item xs={12}>
          <TermsAndConitionInnerTitle param1="5. Redemption and Use" />
        </Grid>
        <Grid item xs={12} sx={{ mt: { xs: 1, sm: 1 } }}>
          <List>
            {orders.map((order, index) => (
              <ListItem key={order.id} dense sx={{ pl: '0' }}>
                {order?.icon && (
                  <ListItemIcon sx={{ color: 'inherit' }}>{order?.icon}</ListItemIcon>
                )}
                {order?.content && (
                  <ListItemText
                    primary="&#9679;"
                    primaryTypographyProps={{
                      fontSize: { xs: '13.5px', md: '16px' },
                      color: 'secondary.main',
                      fontWeight: { xs: 400, md: 300 },
                      display: 'inline',

                      mr: { xs: '3px', md: '3px' },
                    }}
                    secondary={order?.content}
                    secondaryTypographyProps={{
                      fontSize: { xs: '13.5px', md: '16px' },
                      color: 'primary.main',
                      fontWeight: { xs: 400, md: 400 },
                      display: 'inline',
                    }}
                  />
                )}
              </ListItem>
            ))}
          </List>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

function TermsAndConitionUsageConduct({ giftCardContiner }) {
  const orders = [
    {
      content:
        'All Gift Cards issued through 99gift.ae are valid for a period of one (1) year from the date of issuance, unless a different validity period is expressly stated at the time of purchase. Upon expiry, any unused balance will automatically lapse and shall not be eligible for refund, replacement, or extension, except where such action is required under applicable UAE consumer protection laws',
    },
    {
      content:
        'responsibility to track the validity period and redeem the Gift Card before its expiration rests solely with the customer. 99gift.ae is not obligated to provide reminders or notifications regarding upcoming or expired Gift Cards',
    },
  ];

  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <Grid item xs={12}>
          <TermsAndConitionInnerTitle param1="6. Expiration and Validity" />
        </Grid>
        <Grid item xs={12}>
          <List>
            {orders.map((order, index) => (
              <ListItem key={order.id} dense sx={{ pl: '0' }}>
                {order?.icon && (
                  <ListItemIcon sx={{ color: 'inherit' }}>{order?.icon}</ListItemIcon>
                )}
                {order?.content && (
                  <ListItemText
                    primary="&#9679;"
                    primaryTypographyProps={{
                      fontSize: { xs: '13.5px', md: '16px' },
                      color: 'secondary.main',
                      fontWeight: { xs: 400, md: 300 },
                      display: 'inline',

                      mr: { xs: '3px', md: '3px' },
                    }}
                    secondary={order?.content}
                    secondaryTypographyProps={{
                      fontSize: { xs: '13.5px', md: '16px' },
                      color: 'primary.main',
                      fontWeight: { xs: 400, md: 400 },
                      display: 'inline',
                    }}
                  />
                )}
              </ListItem>
            ))}
          </List>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

function TermsAndConitionIntellectualPropertyRights({ giftCardContiner }) {
  const orders = [
    {
      content: `Digital Gift Cards: Once delivered and activated, they are generally non-refundable and non-cancellable. This is due to their instantaneous digital nature`,
    },
    {
      content: `Refunds may be permitted only in exceptional cases as required under UAE law (for example, where a product is not delivered or is defective through no fault of the purchaser)`,
    },
    {
      content: `Any refund that may be approved will be processed to the original method of payment, or as credit, at our discretion and in compliance with UAE consumer regulations.`,
    },
  ];

  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <Grid item xs={12}>
          <TermsAndConitionInnerTitle param1="7. Refunds & Cancellations" />
        </Grid>
        <Grid item xs={12}>
          <List>
            {orders.map((order, index) => (
              <ListItem key={order.id} dense sx={{ pl: '0' }}>
                {order?.icon && (
                  <ListItemIcon sx={{ color: 'inherit' }}>{order?.icon}</ListItemIcon>
                )}
                {order?.content && (
                  <ListItemText
                    primary="&#9679;"
                    primaryTypographyProps={{
                      fontSize: { xs: '13.5px', md: '16px' },
                      color: 'secondary.main',
                      fontWeight: { xs: 400, md: 300 },
                      display: 'inline',

                      mr: { xs: '3px', md: '3px' },
                    }}
                    secondary={order?.content}
                    secondaryTypographyProps={{
                      fontSize: { xs: '13.5px', md: '16px' },
                      color: 'primary.main',
                      fontWeight: { xs: 400, md: 400 },
                      display: 'inline',
                    }}
                  />
                )}
              </ListItem>
            ))}
          </List>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

function TermsAndConitionThirdPartySites({ giftCardContiner }) {
  const orders = [
    {
      content: `You agree not to use Gift Cards for unlawful or unauthorized purposes, including fraud, money laundering, or illicit transactions`,
    },
    {
      content: `We reserve the right to block, suspend or cancel any Gift Card or transaction suspected of fraudulent or unauthorized activity.`,
    },
  ];

  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <Grid item xs={12}>
          <TermsAndConitionInnerTitle param1="8. Security and Fraud Prevention" />
        </Grid>
        <Grid item xs={12}>
          <List>
            {orders.map((order, index) => (
              <ListItem key={order.id} dense sx={{ pl: '0' }}>
                {order?.icon && (
                  <ListItemIcon sx={{ color: 'inherit' }}>{order?.icon}</ListItemIcon>
                )}
                {order?.content && (
                  <ListItemText
                    primary="&#9679;"
                    primaryTypographyProps={{
                      fontSize: { xs: '13.5px', md: '16px' },
                      color: 'secondary.main',
                      fontWeight: { xs: 400, md: 300 },
                      display: 'inline',

                      mr: { xs: '3px', md: '3px' },
                    }}
                    secondary={order?.content}
                    secondaryTypographyProps={{
                      fontSize: { xs: '13.5px', md: '16px' },
                      color: 'primary.main',
                      fontWeight: { xs: 400, md: 400 },
                      display: 'inline',
                    }}
                  />
                )}
              </ListItem>
            ))}
          </List>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

function TermsAndConitionDisclaimer({ giftCardContiner }) {
  const orders = [
    {
      content: `1.	To the maximum extent permitted by UAE law, 99gift.ae is not liable for indirect, incidental, or consequential damages arising from the use, inability to use, or misuse of Gift Cards.`,
    },
    {
      content: `2.	We are not responsible for the quality, availability, or performance of goods or services purchased with Gift Cards; such matters should be addressed directly with the issuer or merchant.`,
    },
  ];

  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <Grid item xs={12}>
          <TermsAndConitionInnerTitle param1="9. Liability and Limitations" />
        </Grid>
        <Grid item xs={12}>
          <List>
            {orders.map((order, index) => (
              <ListItem key={order.id} dense sx={{ pl: '0' }}>
                {order?.icon && (
                  <ListItemIcon sx={{ color: 'inherit' }}>{order?.icon}</ListItemIcon>
                )}
                {order?.content && (
                  <ListItemText
                    primary="&#9679;"
                    primaryTypographyProps={{
                      fontSize: { xs: '13.5px', md: '16px' },
                      color: 'secondary.main',
                      fontWeight: { xs: 400, md: 300 },
                      display: 'inline',

                      mr: { xs: '3px', md: '3px' },
                    }}
                    secondary={order?.content}
                    secondaryTypographyProps={{
                      fontSize: { xs: '13.5px', md: '16px' },
                      color: 'primary.main',
                      fontWeight: { xs: 400, md: 400 },
                      display: 'inline',
                    }}
                  />
                )}
              </ListItem>
            ))}
          </List>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

function TermsAndConitionIndemnification({ giftCardContiner }) {
  const paragraph = `All content, trademarks, logos, and materials on this Website are the property of 99gift.ae or its licensors and are protected by UAE and international intellectual property law. You may use our content only for your personal and non-commercial use.`;

  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <Grid item xs={12}>
          <TermsAndConitionInnerTitle param1="10. Intellectual Property" />
        </Grid>
        <Grid item xs={12}>
          <TermsAndConitionSimpleParagraph paragrpahData={paragraph} />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

function TermsAndConitionTermination({ giftCardContiner }) {
  const paragraph = `We may update or modify these Terms at any time. The updated version will be effective from the date it is published on this Website. Your continued use of the Website and Gift Cards constitutes your acceptance of the changes.`;

  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <Grid item xs={12}>
          <TermsAndConitionInnerTitle param1="11. Modifications to Terms" />
        </Grid>
        <Grid item xs={12}>
          <TermsAndConitionSimpleParagraph paragrpahData={paragraph} />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

function TermsAndConitionGoverningLaw({ giftCardContiner }) {
  const paragraph = `These Terms are governed by the laws of the United Arab Emirates and applicable federal regulations. Any dispute arising from these Terms will be resolved in the competent courts of the UAE, in accordance with local consumer protection laws and applicable regulations`;

  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <Grid item xs={12}>
          <TermsAndConitionInnerTitle param1="12. Governing Law and Jurisdiction" />
        </Grid>
        <Grid item xs={12}>
          <TermsAndConitionSimpleParagraph paragrpahData={paragraph} />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

function TermsAndConitionReportAbuse({ giftCardContiner }) {
  const paragraph = `Nothing in these Terms is intended to limit your statutory rights under applicable UAE law, including rights under the UAE Consumer Protection Law (Federal Law No. 15 of 2020). In the event of any conflict between these Terms and mandatory UAE consumer protection law, the latter shall prevail. `;

  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <Grid item xs={12}>
          <TermsAndConitionInnerTitle param1="13. Consumer Rights (UAE)" />
        </Grid>
        <Grid item xs={12}>
          <TermsAndConitionSimpleParagraph paragrpahData={paragraph} />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

function TermsAndConitionSharedPersonalInformation({ giftCardContiner }) {
  const paragraph = `For questions regarding these Terms, customer support, or Gift Card issues, please contact us via the support details listed on the Contact Us page of 99gift.ae.`;

  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <Grid item xs={12}>
          <TermsAndConitionInnerTitle param1="Shared" param2="Personal Information" />
        </Grid>
        <Grid item xs={12}>
          <TermsAndConitionSimpleParagraph paragrpahData={paragraph} />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

function TermsAndConitionGeneral({ giftCardContiner }) {
  const paragraph = `99gift will use information only in accordance with the Privacy Policy under which the information was collected unless we have received explicit authorization.`;

  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          ...giftCardContiner,
        }}
      >
        <Grid item xs={12}>
          <TermsAndConitionInnerTitle param2="General" />
        </Grid>
        <Grid item xs={12}>
          <TermsAndConitionSimpleParagraph paragrpahData={paragraph} />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
